import { render, staticRenderFns } from "./VacancesSelection.vue?vue&type=template&id=c673efdc&scoped=true"
import script from "./VacancesSelection.vue?vue&type=script&lang=js"
export * from "./VacancesSelection.vue?vue&type=script&lang=js"
import style0 from "./VacancesSelection.vue?vue&type=style&index=0&id=c673efdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c673efdc",
  null
  
)

export default component.exports